import {
  LoginSuccessPage,
  NavigationHandler,
  PlatformProvider,
} from '@elva/platform';
import { useToast } from '@elva/ui';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { frontdeskPlatformConfig } from '@/app/config/platform';
import { queryClient } from '@/lib/queryClient';
import { registerToastNotifier } from '@/lib/toastBridge';

const LOGO_SRC = '/logo.svg';

function ToastBridgeWirer() {
  const { toast } = useToast();
  useEffect(() => {
    registerToastNotifier((message) => {
      toast({ title: 'Error', description: message, variant: 'error' });
    });
  }, [toast]);
  return null;
}

export function AppRoot() {
  return (
    <PlatformProvider config={frontdeskPlatformConfig} logoSrc={LOGO_SRC} queryClient={queryClient}>
      <ToastBridgeWirer />
      <NavigationHandler />
      <Outlet />
    </PlatformProvider>
  );
}

export function LoginOkRoute() {
  return <LoginSuccessPage logoSrc={LOGO_SRC} redirectTo="/" />;
}
